var userAgent = require('../internals/engine-user-agent');

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/engine-is-ios.js
// module id = 402
// module chunks = 0